import IntelFeedCard from './IntelFeedCard'

export default IntelFeedCard
